module.exports = __webpack_public_path__ + "static/up_arrow1-b98022fcfbaaaa014fbc6fb118802fd4.png";